import { PropsWithChildren, useContext } from 'react'
import { HotelContext } from '../contexts/HotelContext'
import { Navigate, useLocation } from 'react-router'

export const ReservationRouteGuard = ({ children }: PropsWithChildren<any>) => {
  const { reservation, hotel } = useContext(HotelContext)
  const location = useLocation()

  if (!reservation) {
    return (
      <Navigate
        to={{
          pathname: `/hotel/${hotel.hotelId}/login`,
          search: `redirectUri=${location.pathname}`,
        }}
        replace
      />
    )
  }

  return children
}
